import * as React from 'react'

import { Section } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import ErrorBoundary from 'modules/core/components/ErrorBoundary'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import Page from 'modules/layout/components/Page'
import Header from 'modules/layout/components/Page/Header'

import NavigatorHeader from './Navigator'
import type FaceRecognitionLogsForm from './form'

interface Props {
  employeeId: number
  employeeFullName: string
  logsForm: FaceRecognitionLogsForm
  contractStartsOn: Date | null
}

const Layout = ({
  children,
  employeeId,
  employeeFullName,
  logsForm,
  contractStartsOn,
}: React.PropsWithChildren<Props>) => {
  const { navigation } = useNavigation()

  const title = i18n.t('time_tracking.settings.face_recognition.logs.title', {
    name: employeeFullName,
  })

  const description = i18n.t('time_tracking.settings.face_recognition.logs.description')

  const referenceDate = moment(contractStartsOn || moment().subtract(1, 'month'))

  const minDate = referenceDate.startOf('month')
  const maxDate = moment()

  return (
    <Page>
      <Page.Header>
        <Header.Title
          options={[
            {
              title: i18n.t('time_tracking.settings.employees.actions.show'),
              to: navigation.employees.id.fullPath({ id: employeeId }),
            },
          ]}
        >
          {title}
        </Header.Title>
        <NavigatorHeader logsForm={logsForm} minDate={minDate} maxDate={maxDate} />
      </Page.Header>
      <Page.Body>
        <Section.FullWidth illustration="group" title={title} description={description}>
          <ErrorBoundary>{children}</ErrorBoundary>
        </Section.FullWidth>
      </Page.Body>
    </Page>
  )
}

export default observer(Layout)
